module.exports = __webpack_public_path__ + "img/IAFT_Logo_white.2dda1824.png";